import { request } from '../request';

export const voiceTranscriptionApi = {
  getAudioMode: () => request('/agent/audio-mode'),

  updateAudioMode: (audio_mode) =>
    request('/agent/audio-mode', {
      method: 'PUT',
      body: JSON.stringify({ audio_mode })
    }),

  getTranscriptionProviders: () => request('/agent/transcription-providers'),

  updateTranscriptionProvider: (provider_id) =>
    request('/agent/transcription-provider', {
      method: 'PUT',
      body: JSON.stringify({ provider_id })
    }),

  getTranscriptionProviderType: () => request('/agent/transcription-provider-type'),

  updateTranscriptionProviderType: (transcription_provider_type) =>
    request('/agent/transcription-provider-type', {
      method: 'PUT',
      body: JSON.stringify({ transcription_provider_type })
    }),

  getLocalWhisperStatus: () => request('/agent/local-whisper-status')
};
